import Notifications from "nvent-web/components/Notifications/Notifications";
import Header from "./Header";
import { Sidebar } from "./Sidebar/Sidebar";
import { Outlet } from "react-router";
import { NotificationsStore } from "nvent-web/stores/Notifications";
import AddToHomeScreenPrompt from "~/nvent-web/components/AddToHomeScreenPrompt";
import { Advertisements } from "./Advertisements";
import withTracker from "nvent-web/services/withTracker";
import compose from "~/nvent-web/utils/compose";
import { withRouter } from "~/nvent-web/utils/withRouter";

type AuthenticatedAppLayoutProps = {
  notifications: NotificationsStore;
};

const AuthenticatedAppLayout = ({
  notifications,
}: AuthenticatedAppLayoutProps) => {
  return (
    <Sidebar>
      <Header />
      <Notifications notifications={notifications} />
      <Outlet />
      <AddToHomeScreenPrompt />
      <Advertisements />
    </Sidebar>
  );
};

const AuthenticatedAppLayoutComponent = compose<AuthenticatedAppLayoutProps>(
  withRouter,
  withTracker
)(AuthenticatedAppLayout);

AuthenticatedAppLayoutComponent.displayName = "AuthenticatedAppLayout";

export default AuthenticatedAppLayoutComponent;
